import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { QRIcon } from 'src/app/models/qr-icon.model';
import { QRTabs } from 'src/app/models/qr-tabs.model';

@Component({
  selector: 'qr-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent {
  @Input() config!: QRTabs;
  @Input() isDisabled?: boolean = false;
  @Output() tabChange: EventEmitter<number> = new EventEmitter<number>();
  idTabActive: number = 0;
  randomID: number | undefined;

  readonly ICON_ERROR = Constants.ICONS.ERROR;
  readonly ICON_COLOR_ERROR_900 = QRIcon.COLOR_ERROR_900;

  transformX: string = '';

  constructor(private readonly cd: ChangeDetectorRef) {
    this.randomID = Math.floor(Math.random() * 9999) + 1;
  }

  // ngAfterViewInit(): void {
  //   if (this.config.defaultTab) {
  //     this.selectTab(this.config.defaultTab);
  //     console.log('entro');
  //   }
  //   this.cd.detectChanges();
  // }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['config']) {
      return;
    }
    this.selectTab(this.config.defaultTab ?? 0);
  }

  ngDoCheck(): void {
    this.getLineActiveTransformX();
  }

  selectTab(id: number): void {
    if (!this.isDisabled) {
      this.idTabActive = id;
      this.tabChange.emit(this.idTabActive);
      this.getLineActiveTransformX();
    }
  }

  getLineActiveTransformX(): void {
    let transformX = '';
    this.getLineActiveWidth();
    if (this.idTabActive >= 0) {
      const tab = document.getElementById(
        this.idTabActive.toString() + '-' + this.randomID
      );
      if (tab) {
        transformX = 'translateX(' + tab.offsetLeft + 'px' + ')';
      }
    }
    this.transformX = transformX;
  }

  getLineActiveWidth(): void {
    let width = 0;
    if (this.idTabActive >= 0) {
      const tab = document.getElementById(
        this.idTabActive.toString() + '-' + this.randomID
      );
      if (tab) {
        const line = document.getElementById('line-active-' + this.randomID);
        if (line) {
          line.style.width = tab.getBoundingClientRect().width + 'px';
        }
      }
    }
  }

  getIconColor(tabIndex: number): string {
    const IS_ACTIVE = this.idTabActive === tabIndex;

    if (IS_ACTIVE && !this.isDisabled) return QRIcon.COLOR_PRIMARY_700;
    if (IS_ACTIVE && this.isDisabled) return QRIcon.COLOR_PRIMARY_100;
    if (!IS_ACTIVE && !this.isDisabled) return QRIcon.COLOR_GREY_700;

    return QRIcon.COLOR_GREY_300;
  }
}
